export const BRAND_THEMES = ['iflow', 'purple', 'mint', 'forest', 'ocean'] as const;

export type BrandTheme = (typeof BRAND_THEMES)[number];

export const DEFAULT_BRAND_THEME: BrandTheme = 'iflow';

export function normalizeBrandTheme(value: unknown): BrandTheme {
  return typeof value === 'string' && BRAND_THEMES.includes(value as BrandTheme)
    ? (value as BrandTheme)
    : DEFAULT_BRAND_THEME;
}

export function applyBrandTheme(value: unknown): BrandTheme {
  const theme = normalizeBrandTheme(value);

  if (typeof document !== 'undefined') {
    document.documentElement.dataset.theme = theme;
  }

  return theme;
}
